import { sqliteTable, text, integer } from "drizzle-orm/sqlite-core";
import { timestamps } from "../utils/fields";

export const offlineAlbums = sqliteTable("offline_albums", {
  ...timestamps,
  id: text("id").primaryKey(),
  title: text("title").notNull(),
  artistDisplayText: text("artist_display_text").notNull(),
  image: text("image"),
  artistIds: text("artist_ids", { mode: "json" }).notNull().$type<string[]>(),
  releaseDate: text("release_date"),
  hasPrivateSong: integer("has_private_song", { mode: "boolean" }).notNull(),
  privateSongIds: text("private_song_ids", { mode: "json" })
    .notNull()
    .default("[]")
    .$type<string[]>(),
});

export type OfflineAlbum = typeof offlineAlbums.$inferSelect;
